import { render } from "./ZoomableImg.vue?vue&type=template&id=650cd610&scoped=true"
import script from "./ZoomableImg.vue?vue&type=script&lang=js"
export * from "./ZoomableImg.vue?vue&type=script&lang=js"

import "./ZoomableImg.vue?vue&type=style&index=0&id=650cd610&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650cd610"]])

export default __exports__